import { Select } from "./Select";
import { Checkbox } from "./Checkbox";
import { Text } from "./Text";
import { DatePicker } from "./DatePicker";
import { CheckboxGroup } from "./CheckboxGroup";

export const FormController = {
  Select,
  Checkbox,
  Text,
  DatePicker,
  CheckboxGroup,
};
